import { render, staticRenderFns } from "./editTeacher.vue?vue&type=template&id=3e4d957c"
import script from "./editTeacher.vue?vue&type=script&lang=js"
export * from "./editTeacher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports